import { Routes, Route } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import { AuthProvider } from '@/hooks/useAuth'
import Landing from '@/pages/Landing'
import NotFound from '@/pages/NotFound'
import AdminLeads from '@/pages/admin/Leads'
import AdminResources from '@/pages/admin/Resources'

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/admin/leads" element={<AdminLeads />} />
        <Route path="/admin/resources" element={<AdminResources />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            borderRadius: '10px',
            background: '#2D2042',
            color: '#fff',
            fontFamily: "'DM Sans', sans-serif",
          },
        }}
      />
    </AuthProvider>
  )
}
